import { render, staticRenderFns } from "./DetailNonKomship.vue?vue&type=template&id=7d364e60&"
import script from "./DetailNonKomship.vue?vue&type=script&lang=js&"
export * from "./DetailNonKomship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports